import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import useMediaQuery from 'housecall-ui/dist/DesignSystem/Styles/useMediaQuery';
import useTheme from 'housecall-ui/dist/DesignSystem/Styles/useTheme';

import { PricingFormType } from '../types/types';
import { isPresent } from '../utils/isPresent';

import { OnlineBookingCard } from './OnlineBookingCard';

const useStyles = makeStyles(() => ({
  truncateText: {
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
  },
  imageClass: {
    display: 'block',
    maxHeight: '120px',
    width: `160px`,
    borderRadius: '3px',
  },
  columnContainer: {
    height: '100%',
  },
}));

type Props = {
  pricingForm: PricingFormType;
  onFormClick?: () => void;
};

const PriceFormCard = ({ pricingForm, onFormClick }: Props) => {
  const { truncateText, imageClass, columnContainer } = useStyles();
  const { name, description = '', imageUrl = '' } = pricingForm;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const showMobileVersion = isMobile && imageUrl;

  return (
    <Box>
      <OnlineBookingCard onClick={onFormClick}>
        <Box p={2}>
          <Grid
            container
            wrap={showMobileVersion ? 'wrap' : 'nowrap'}
            direction={showMobileVersion ? 'column-reverse' : 'row'}
            justify="space-between"
            data-testid="service-card"
            spacing={1}
          >
            <Grid item xs={12}>
              <Grid container className={columnContainer} wrap="wrap" direction="column">
                <Grid item>
                  <Typography gutterBottom variant="subtitle2">
                    {name}
                  </Typography>
                </Grid>
                {isPresent(description) && (
                  <Grid item>
                    <Typography className={truncateText} variant="body2" color="textSecondary">
                      {description}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            {isPresent(imageUrl) && (
              <Grid item>
                <img alt="service" className={imageClass} src={imageUrl} />
              </Grid>
            )}
          </Grid>
        </Box>
      </OnlineBookingCard>
    </Box>
  );
};

export default PriceFormCard;
